import type { TripCashFigure } from '@chukua/common';

/** One line saying where a driver's cash for the trip stands, in the office's words. */
export function cashPositionSentence(figure: Pick<TripCashFigure, 'direction' | 'status'>): string {
  if (figure.direction === 'settled') return 'Nothing owed either way';
  if (figure.direction === 'company_owes')
    return figure.status === 'carried' ? 'The company owes the driver; left on the driver ledger' : 'The company owes the driver';
  return figure.status === 'carried' ? 'The driver owes the company; left on the driver ledger' : 'The driver owes the company';
}

/** Whether the office can still do something about this figure: only an undecided one with a balance the driver owes can take cash back. */
export function canReturnCash(figure: Pick<TripCashFigure, 'balanceMinor' | 'status'>, pendingExpenses: number): boolean {
  return pendingExpenses === 0 && figure.status === 'open' && figure.balanceMinor > 0;
}

/** Whether the office can close the figure by carrying it. A pending expense moves the balance, so it has to be decided first. */
export function canCarryBalance(figure: Pick<TripCashFigure, 'status'>, pendingExpenses: number): boolean {
  return pendingExpenses === 0 && figure.status === 'open';
}
